var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative flex items-center justify-center"},[_c('img',{staticClass:"absolute animate__animated",class:_vm.iconPhoneClass,attrs:{"src":"/icons/phone-app.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"absolute animate__animated",class:_vm.iconWebClass,attrs:{"src":"/icons/web-app.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }